import { createFileRoute } from '@tanstack/react-router'
import { OAuthContinue } from '../../../features/oauth/components/oauth-continue'

// Lives under /app so the studio's own sign-in and onboarding screens handle anyone not signed in;
// the assistant's signed request stays in the URL through any redirect, such as Google's.
export const Route = createFileRoute('/app/oauth/login')({
  component: OAuthContinue,
})
